<template>
    <table class="table m-0">
        <thead>
            <tr>
                <th>Name</th>
                <th>Campaign</th>
                <th>Type</th>
                <th>Location</th>
                <th>Sent At</th>
            </tr>
        </thead>
        <tbody>
            <tr v-for="invite in invites" :key="`contact-invite-${invite.id}`">
                <td>{{ invite.sender ? invite.sender : '---' }}</td>
                <td>{{ invite.campaign_name }}</td>
                <td>{{ invite.campaign_type | capitalize }}</td>
                <td>{{ invite.location_name }}</td>
                <td>{{ invite.sent_at | inviteDate(timezone) }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script>
    import _ from "lodash";

    export default {
        props: {
            invites: {
                type: Array,
                required: true,
            },
            timezone: {
                required: false,
                default: null
            }
        },

        filters: {
            inviteDate(value, timezone){
                let date;
                if (!timezone){
                    timezone = moment.tz.guess();
                }
                if (_.has(value, 'date')) {
                    date = moment.tz(value.date, 'UTC').tz(timezone);
                }

                if (moment(value).isValid()) {
                    date = moment.tz(value, 'UTC').tz(timezone);
                }

                if (date) {
                    return date.format('YYYY/MM/DD LT');
                }

                return value;
            }
        },
    }
</script>
